import React from "react";
import Result from "./Results/Results";
import SearchHead from "./SearchHead";

let listItems = [
    { value: "all", label: "Összes" },
    { value: "author", label: "Szerző" },
    { value: "reader", label: "felolvasó" },
    { value: "publisher", label: "kiadó" },
    { value: "title", label: "cím" },
    { value: "series", label: "sorozat" },
    { value: "tags", label: "címkék" },
    { value: "genres", label: "műfajok" }
];

const SearchResult = ({ searchInput, data, handleResultClick, onType}) => {
    const [category, setCategory] = onType;

    const handleSearchChange = value => {
        setCategory(value);
        // console.log('type in SerachResult: ', value)
    };

    return (
        <div className="search-option">
            <SearchHead list={listItems} data={data} searchChange={handleSearchChange} searchValue={category} />
            <Result
                category={category}
                searchInput={searchInput}
                data={data}
                onResultClick={handleResultClick}
            />
        </div>
    );
};

export default SearchResult
